export class ServerErrorHandler {
    constructor(error) {
        this.error = error
    }

    getMessage(defaultMessage = "خطا در دریافت اطلاعات از سرور", reason) {

        if (this.error.response && this.error.response.data.message) {
            return this.error.response.data.message
        } else if (this.error.response && this.error.response.data.error) {
            return `${this.error.response.data.error} (${this.error.response.data.status})`
        } else if (this.error.response && this.error.response.data.detail) {
            return `${this.error.response.data.detail} (${this.error.response.data.status})`
        } else if (this.error.response && this.error.response.data.status === 502) {
            return "502"
        }else if (reason.response && reason.response.status === 403) {
            return "403"
        } else {
            return JSON.stringify(reason).length > 2 ? JSON.stringify(reason) : `error : ${reason}`
        }
    }

    getStatusCode() {
        if (this.error.response && this.error.response.data.status) {
            return this.error.response.data.status
        } else if (this.error.response && this.error.response.status) {
            return this.error.response.status
        }else {
            return -1
        }
    }

}